/*
SaiKrishna 10/06/2022 3075220937 Removed unnecessary console.log statements
Suresh Peddavoora 10/28/2022 3075220937   Added Class Name for Text Fields and Buttons
Ashraf 10/30/2022 3075220937 fixed table pagination issue
uresh peddavoora 11/01/2022  3075220937 Changed Position of Buttons.
Ashraf 11/01/2022 3075220937 renamed button labels
saikrishna 11/03/2022 3075220937 changed the paginationOptions
Ashraf 11/24/2022 3075220937 modified test Api payload.
Akhila 11/29/2022 3075220937 integrated returnType in payLoad
Suresh peddavoora 11/30/2022 3075220937 Added Class Name for Table Pagination Alignment Issue.
Akhila 11/30/2022 3075220937 rename Test button to search
Sohel 12/16/2022 3075220937 Added Account Number field data
Ashraf 12/18/2022 3075220937 fixed pagination api call issue
Sohel 12/22/2022 3075220937 rename Test Button
Akhila 01/09/2023 3075220937 Fixed Account number column data
Raghu 02/23/2023 3075220937 fixed new Ui changes
Raghu 02/28/2023 3075220937 added new class table
Akhila 05/09/2023 3075220937 Bug fixed account number in column
Prakash 9/05/2023 3075220937 add theming classname
Sohel 10/09/2023 3075220937 Changed Account Number Field key.
Sohel 10/19/2023 3075220937 Fixed Account Number populate issue.
*/
import { Grid, TextField, Button, FormHelperText, TablePagination } from '@material-ui/core';
import { tableIcons } from '../../../../../components/TableIcons';
import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from '../../../../../themes/ThemeProvider';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
// import MaterialTable from "material-table";
import { httpPaginationPost } from './../../../../../util/Rest';
import { useRef } from 'react';
import { defaultRows } from '../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import { tablePageRows } from '../../../../../constants/ReusableConstants';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles({
  input: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  border: {
    border: '1px solid gray',
    margin: '0px 2px',
    padding: '4px',
  },
});

const GenerateFields = ({
  ruleGroupData,
  selectedFieldList,
  formValues,
  formData,
  result,
  submit,
  setSubmit,
}) => {
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const useClasses = useStyles();
  const [testFieldData, setTestFieldData] = useState(null);
  const [rows, setRows] = useState(defaultRows);
  const [errorMsg, setErrorMsg] = useState('');
  const tableRef = useRef();
  const pageRef = useRef(null);

  const { basicInfoData } = useSelector(({ addRuleGroup }) => addRuleGroup);

  useEffect(() => {
    if (tableRef?.current) {
      (submit || testFieldData) && tableRef.current.onQueryChange();
    }
  }, [submit, testFieldData]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setErrorMsg("");
  //   }, 3000);
  // }, [errorMsg]);

  const initialValues = {
    startAccountNo: '',
  };

  const schema = Yup.object().shape({
    startAccountNo:
      basicInfoData?.category === 'CO'
        ? Yup.number().required('Starting Account Number is required')
        : '',
  });

  const handleSubmit = (values) => {
    if (formValues) {
      setSubmit(true);
      const passValues = {
        addRule: formData.map((item) => {
          return {
            // createdBy: item?.createdBy ? item?.createdBy : "",
            // dataType: item?.dataType || item?.returnType,
            // groupCode: ruleGroupData?.code
            //   ? ruleGroupData?.code?.toUpperCase()
            //   : formValues?.code?.toUpperCase(),
            ruleCode: item?.ruleCode ? item?.ruleCode : '',
            formulaExpression: item?.formulaExpression ? item?.formulaExpression : '',
            ruleId: item?.ruleId || 0,
          };
        }),
        result: result,
        fieldListCode: basicInfoData?.fieldListCode ? basicInfoData?.fieldListCode : '',
        limit: 15,
        page: 1,
        startAccountNo: values?.startAccountNo ? values?.startAccountNo : '',
        category: basicInfoData?.category ? basicInfoData?.category : '',
      };
      setTestFieldData(passValues);
    }
  };

  const columns = [
    {
      title: 'Result',
      field: 'result',
      minWidth: '250px',
    },
    {
      title: 'Account Number',
      field: 'Account.Account Number',
      // type: "numeric",
      minWidth: '150px',
    },
    {
      title: 'Fields',
      minWidth: '450px',
      render: (rowData) => {
        const fieldsResult = [];
        for (const [key, value] of Object.entries(rowData.fields)) {
          if (key !== 'dbacct' && key !== 'tableData' && key !== 'result') {
            fieldsResult.push({
              key: key,
              value: value,
            });
          }
        }
        return (
          <div>
            {fieldsResult.map((each, index) => {
              return (
                <span className={useClasses.border} key={index}>
                  {`${each.key} = ${each.value} `}{' '}
                </span>
              );
            })}
          </div>
        );
      },
    },
  ];

  const columns2 = [
    {
      title: 'Result',
      field: 'result',
      minWidth: '250px',
    },
    {
      title: 'Fields',
      minWidth: '450px',
      render: (rowData) => {
        const fieldsResult = [];
        for (const [key, value] of Object.entries(rowData.fields)) {
          if (key !== 'dbacct' && key !== 'tableData' && key !== 'result') {
            fieldsResult.push({
              key: key,
              value: value,
            });
          }
        }
        return (
          <div>
            {fieldsResult.map((each, index) => {
              return (
                <span className={useClasses.border} key={index}>
                  {`${each.key} = ${each.value} `}{' '}
                </span>
              );
            })}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="col new-standard-textfields">
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const { values, handleChange, handleBlur, touched, errors, handleReset, handleSubmit } =
              props;
            return (
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                {basicInfoData?.category === 'CO' ? (
                  <div className="form-row global-field-textfields new-standard-textfields">
                    <div className="col-md-6 col-lg-4 form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Starting Account Number`}
                        label="Starting Account Number"
                        type="number"
                        className={` ${classes.labelName}`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="startAccountNo"
                        value={values.startAccountNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        required
                        error={Boolean(errors.startAccountNo && touched.startAccountNo)}
                      />
                      <FormHelperText style={{ color: 'red' }}>
                        {touched.startAccountNo && errors.startAccountNo && errors.startAccountNo}
                      </FormHelperText>
                    </div>
                    <div className="col-md-6 col-lg-4 new-standard-textfields">
                      <Button
                        variant="outlined"
                        type="reset"
                        onClick={() => {
                          setTestFieldData({});
                          setSubmit(true);
                        }}
                        className={`reset-btn mx-1`}
                      >
                        Reset
                      </Button>
                      <Button type="submit" variant="outlined" className={`search-btn mx-1`}>
                        Run Test
                      </Button>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </form>
            );
          }}
        </Formik>
        {errorMsg && (
          <Alert className="mb-2" severity="error">
            {errorMsg}
          </Alert>
        )}
        <Grid item xs={12} className="">
          <div className="custom-table global-field-table">
            <GuiTable
              title=""
              columns={basicInfoData?.category === 'CO' ? columns : columns2}
              icons={tableIcons}
              tableRef={tableRef}
              // data={tableData || []}
              data={(query) =>
                new Promise((resolve) => {
                  const url = `rules/test/bre/expressions`;
                  const passValues = {
                    addRule: formData.map((item) => {
                      return {
                        // createdBy: item?.createdBy ? item?.createdBy : "",
                        // dataType: item?.dataType || item?.returnType,
                        // groupCode: ruleGroupData?.code
                        //   ? ruleGroupData?.code?.toUpperCase()
                        //   : formValues?.code?.toUpperCase(),
                        ruleCode: item?.ruleCode,
                        formulaExpression: item?.formulaExpression ? item?.formulaExpression : '',
                        ruleId: item?.ruleId || 0,
                      };
                    }),
                    result: result,
                    formulaType: basicInfoData?.formulaType,
                    returnType: basicInfoData?.returnType ? basicInfoData.returnType : null,
                    code: basicInfoData?.code,
                    // fieldListCode: basicInfoData?.fieldListCode ? basicInfoData?.fieldListCode : "",
                    startAccountNo: testFieldData?.startAccountNo
                      ? testFieldData?.startAccountNo
                      : '',
                    limit: query?.pageSize ? query.pageSize : null,
                    page: query.page ? query.page + 1 : 1,
                    category: basicInfoData?.category ? basicInfoData?.category : '',
                    formulaRuleGroupId: basicInfoData?.groupId ? basicInfoData?.groupId : 0,
                  };
                  if (basicInfoData?.category === '') {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                  } else {
                    pageRef.current = query.page;
                    httpPaginationPost(url, passValues)
                      .then((response) => {
                        if (response?.status === 200) {
                          if (response?.data?.message) {
                            setErrorMsg(response?.data?.message);
                          }
                          const data = response.data.response.result;
                          setSubmit(false);
                          resolve({
                            data: data.length > 0 ? data : [],
                            page: pageRef.current,
                            totalCount: response.data.response.count,
                          });
                        } else {
                          resolve({
                            data: [],
                            page: 0,
                            totalCount: 5,
                          });
                          dispatch({
                            type: 'FETCH_ERROR',
                            payload: response && response.message ? response.message : null,
                          });
                        }
                      })
                      .catch((response) => {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      });
                  }
                })
              }
              options={{
                toolbar: false,
                search: false,
                pageSize: rows,
                sorting: false,
                emptyRowsWhenPaging: false,
                headerStyle: {
                  fontWeight: 'bold',
                  fontSize: '0.938rem',
                  padding: '16px',
                },
              }}
              onChangeRowsPerPage={(event) => {
                setRows(event);
              }}
              components={{
                Pagination: (props) => (
                  <div className="global-field-table-footer">
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: { 'aria-label': 'Rows per screen' },
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                ),
              }}
            />
          </div>
        </Grid>
      </div>
    </>
  );
};

export default GenerateFields;
